import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    locationId: null,
    prep_type: null,
    table: null,
    service_type: null
};
const qrSlice = createSlice({
    name: 'qr',
    initialState: initialState,
    reducers: {
        setQrParams(state, action) {
            const { locationId, prep_type, table, service_type } = action.payload;
            state.locationId = locationId;
            state.prep_type = prep_type;
            state.table = table;
            state.service_type = service_type;
        },
        resetQrParams(state) {
            state.locationId = null;
            state.prep_type = null;
            state.table = null;
            state.service_type = null;
        }
    }
});
export const { setQrParams, resetQrParams } = qrSlice.actions;
export const selectQrParams = (state) => state.qr;
export const qrReducer = qrSlice.reducer;
